import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

import { environment } from '../../environments/environment';

import { ApiResponse } from './models/api-response';
import { GenericItem } from './models/generic-item';
import { SimulateResult } from './models/simulate-result';

import { ServicerProvider } from './servicer';
import { SimulateResultType } from '../../types/simulate-result-type';

const BASE_URL = '/v2/simulate';

/**
 * シミュレート のプロバイダー.
 */
@Injectable()
export class SimulateServiceProvider {
  private readonly empty = null;

  /** 結果. */
  private simulateResult: BehaviorSubject<SimulateResult | null> = new BehaviorSubject<SimulateResult>(this.empty);

  /** インターバルのSubscription. */
  private intervalSubscription: Subscription = null;

  /** 実行中. */
  private processing = false;

  constructor(
    private servicer: ServicerProvider
  ) { }

  /**
   * 実行処理.
   * 
   * @returns Observable<ApiResponse>
   */
  execute(): Observable<ApiResponse> {
    const url = `${BASE_URL}/execute`;
    return this.servicer.postApi(url, null);
  }

  /**
   * シミュレートの結果取得処理.
   *
   * @returns Observable<GenericItem<SimulateResult>>
   */
  result(): Observable<GenericItem<SimulateResult>> {
    const url = `${BASE_URL}/result`;
    return this.servicer.get<GenericItem<SimulateResult>>(url);
  }

  /**
   * 結果を取得します.
   */
  resultCheck(): Observable<SimulateResult> {
    return this.simulateResult.asObservable().filter((st) => st !== null);
  }

  /**
   * 結果を定期的に確認します.
   */
  startResultCheck() {
    this.getResult().subscribe((res) => {
      if (res.result !== SimulateResultType.RUNNING) {
        return;
      }

      this.intervalSubscription = Observable.interval(environment.simulateResultInterval)
        .subscribe(() => this.stopResultCheckExecute());
    });
  }

  /**
   * 結果の確認を停止します.
   */
  stopResultCheck() {
    this.simulateResult.next(this.empty);

    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = null;
    }
  }

  /**
   * 結果の確認を実行します.
   */
  stopResultCheckExecute() {
    of(this.processing)
      .filter((processing) => !processing)
      .pipe(tap(() => this.processing = true))
      .flatMap(() => this.getResult())
      .pipe(tap(() => this.processing = false))
      .subscribe();
  }

  /**
   * 結果を確認します.
   */
  private getResult(): Observable<SimulateResult> {
    return this.result()
      .map((res) => {
        this.simulateResult.next(res.item);
        return res.item;
      })
      .catch((error) => {
        console.error(error);
        return Observable.of(this.simulateResult.value);
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/simulate-service.ts